import { render, staticRenderFns } from "./VehicleDetail.vue?vue&type=template&id=48ac6594"
import script from "./VehicleDetail.vue?vue&type=script&lang=js"
export * from "./VehicleDetail.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetail.vue?vue&type=style&index=0&id=48ac6594&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports